function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 5.90234,
    r: 1,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 10.9023,
    r: 1,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 15.9023,
    r: 1,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDot);
export default __webpack_public_path__ + "static/media/menu_dot.234bbe9700914c8d3eee982a7fa3322d.svg";
export { ForwardRef as ReactComponent };